/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { Loader } from "./loader.js";
import { DefaultBoardServer } from "./default.js";
export const createLoader = (boardServers, opts) => {
    const servers = [...(boardServers ?? [])];
    if (!opts?.disableDefaultProvider) {
        servers.push(new DefaultBoardServer());
    }
    return new Loader(servers);
};
export { SENTINEL_BASE_URL } from "./loader.js";
//# sourceMappingURL=index.js.map